import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ApiService } from '../../../../../@core/service/api.service';
import { SharedDataService } from '../../../../../@core/service/shared-data.service';
import { TreeService } from '../../../../../@core/service/tree.service';
import { CompilationModel } from '../../../../../@models/erp/compilation';
import { SpoStatusData, TransportStatusData, UnitData } from '../../../../../@models/erp/compilationData';
import { AssociatedPfspo, IRelatedOC, LineItemModel } from '../../../../../@models/erp/lineItem';

@Component({
  selector: 'ngx-pfspo-availability',
  templateUrl: './pfspo-availability.component.html',
  styleUrls: ['./pfspo-availability.component.scss']
})
export class PfspoAvailabilityComponent implements OnInit {

  @Input() compilation: CompilationModel;
  @Input() lineItem: LineItemModel;
  @Input() ocPosition: number;
  @Input() pfspo: AssociatedPfspo;
  @Input() spoPosition: number
  @Input() disabled: boolean;
  @Input() popup = false;
  @Input() fromPFSPO = false;

  @Output() close: EventEmitter<any> = new EventEmitter<any>();

  unitData = UnitData;
  spoStatus = SpoStatusData;
  transportStatus = TransportStatusData;

  compilationsToSave: CompilationModel[] = [];

  constructor(protected api: ApiService, protected data: SharedDataService, private tree: TreeService) { }


  async ngOnInit(): Promise<void> {
    // console.log('pre spo position', this.spoPosition)
    // this.spoPosition = this.spoPosition ?? this.pfspo?.pos;
    // console.log('post spo position', this.spoPosition, this.pfspo)
    // console.log('===> oninit', this.popup, this.pfspo);
    // if (!this.fromPFSPO) return;

    if (!this.pfspo) {
      this.pfspo = new AssociatedPfspo();
      this.pfspo.pos = this.spoPosition+1;
      this.pfspo.code = this.compilation.code;
      this.pfspo.doc = this.compilation;
      this.pfspo.docLineItem = this.lineItem;
      this.pfspo.parentPos = this.ocPosition;
      this.pfspo.version = this.compilation.version;
    }

    if (!this.lineItem.relatedOCs) this.lineItem.relatedOCs = [];

    const spoOcMap = this.pfspo.code ? await this.api.getCachedSpoOcMap(this.pfspo.code, this.pfspo.pos) : [];
    // if (this.popup && this.pfspo && !this.lineItem.relatedOCs.find(f => f.doc.code !== this.compilation.code || f.pos !== this.ocPosition)) {
    if (this.popup && this.pfspo) {
      this.lineItem.relatedOCs = spoOcMap?.map(m => ({
        parentPos: m.parentPos,
        pos: m.pos+1,
        quantity: +m.quantity || 0,
        doc: JSON.parse(JSON.stringify(m.doc)),
      }));
      // console.log('===>relatedOCs0', this.pfspo.doc, this.lineItem.relatedOCs);
      if (!this.lineItem.relatedOCs?.find(f => f.doc.code === this.compilation.code)) {
        this.addOC(this.lineItem, { ocPos: this.ocPosition+1, code: this.compilation.code})
      }
    }
  }

  ocQuantityChanged(oc, lidx, value) {
    this.pfspo.quantity = value;
    oc.assignedQ = value;
  }

  onOcSelected(item: LineItemModel, oc: any) {
    this.pfspo.quantity = oc.assignedQ;
    this.addOC(item, oc);
  }

  getDeliveredQ(item: LineItemModel) {
    return item.relatedOCs?.reduce((a, c) => a + (c.doc.completelyInvoiced ? +c.quantity : 0), 0);
  }

  getAssignedQ(item: LineItemModel) {
    return item.relatedOCs?.reduce((a, c) => a + (!c.doc.completelyInvoiced ? +c.quantity : 0), 0);
  }

  getAvailableQ(item: LineItemModel) {
    const quantity = this.pfspo ? this.pfspo.doc.lineItems[this.pfspo.pos-1]?.quantity : item.quantity;
    return quantity - item.relatedOCs?.reduce((a, c) => a + (c.doc.completelyInvoiced ? +c.quantity : 0), 0);
  }

  getPfspoAssignedQ(item: LineItemModel) {
    // this.pfspo.quantity = item.relatedOCs?.reduce((a, c) => a + (+c.quantity), 0);
    return this.pfspo.quantity;
  }

  getFreeQ(item: LineItemModel) {
    const quantity = this.pfspo ? this.pfspo.doc.lineItems[this.pfspo.pos-1]?.quantity : item.quantity;
    return quantity - item.relatedOCs?.reduce((a, c) => a + (+c.quantity), 0);
  }

  async addOC(item: LineItemModel, oc: any) {
    // console.log('add oc', item, oc, this.pfspo.quantity, oc.assignedQ);
    // console.log('compilation id', this.compilation._id);
    if (!this.compilation._id) {
      await this.api.saveCompilation(this.compilation);
      const response = await this.api.loadCompilationByCode(this.compilation.code);
      // console.log('compilation id', response);
      this.compilation._id = response._id;
      // console.log('compilation id', this.compilation._id);
    }
    const doc = await this.api.loadCompilationByCode(oc.code);
    const assoc = new AssociatedPfspo();
    assoc.code = this.pfspo.doc.code;
    assoc.parentPos = oc.ocPos;
    assoc.pos = this.pfspo.pos;
    assoc.quantity = oc.assignedQ || 0;
    assoc.version = this.pfspo.doc.version;
    // console.log('assoc', assoc);
    doc.lineItems[oc.ocPos-1]?.pfspo.push(assoc);

    this.saveCompilation(doc);

    assoc.doc = this.pfspo.doc;
    assoc.docLineItem = this.pfspo.docLineItem;
    const relatedOC: IRelatedOC = {
      parentPos: this.pfspo.pos,
      pos: oc.ocPos,
      quantity: oc.assignedQ || 0,
      doc: JSON.parse(JSON.stringify(doc)),
    }
    if (!item.relatedOCs) item.relatedOCs = [];
    item.relatedOCs.push(relatedOC);

    // console.log('doc und item',this.pfspo.quantity, this.pfspo,  doc.lineItems[oc.ocPos-1], item)
  }

  async removeOC(item: LineItemModel, ocidx: number, spoidx: number) {
    const relatedOC = item.relatedOCs[ocidx];
    const doc = await this.api.loadCompilationByCode(relatedOC.doc.code);
    doc.lineItems[relatedOC.pos-1].pfspo.splice(relatedOC.parentPos-1, 1);
    item.relatedOCs.splice(ocidx, 1);
    this.saveCompilation(doc);
    // console.log('remove oc', doc.code, doc, relatedOC);
    // item.relatedOCs.splice(spoidx, 1);    
  }

  // async toggleCompletelyInvoiced(oc: CompilationModel, state: boolean) {
  //   const doc = await this.api.loadCompilationByCode(oc.code)
  //   doc.completelyInvoiced = oc.completelyInvoiced = state;
  //   this.saveCompilation(doc);
  //   console.log('toggle completely invoiced', doc.completelyInvoiced);
  // }

  saveCompilation(doc: CompilationModel) {
    if (this.popup) {
      if (!this.compilationsToSave.find(f => f.code === doc.code)) this.compilationsToSave.push(doc);
    } else {
      this.api.saveCompilation(doc);
    }
  }

  async save() {
    // for (const doc of this.compilationsToSave) {
    //   this.api.saveCompilation(doc);
    // }
    // this.close.emit(this.pfspo);
    
    // console.log('save', this.pfspo.quantity, this.pfspo);
    this.close.emit(this.pfspo);
  }

  cancel() {
    this.close.emit();
  }

}
